// 22.01.19
import { reduxForm, FieldArray, InjectedFormProps, change } from "redux-form"; // InjectedFormProps
import * as React from "react";
import { Grid, InputLabel } from "@material-ui/core"; //Typography
import {
  FlexGridItem,
  FlexCurrencyInputField,
  FlexTextField,
  FlexTextFieldNumber,
  CheckBoxField,
  SelectField,
  ConditionalField,
  TextArea,
  required,
  DateField,
  timestampToDate,
  dateToTimestamp,
  DisableForRoles,
  HideForRoles,
  EnableForRoles,
  validYear,
  validCurrency,
  validEmail,
  validDate,
  validPhoneNo,
  maxLength50,
} from "./form_utility";
import { connect } from "react-redux";
import {
  IssueType,
  isClaim,
  isComplaint,
  UserRoles,
  isOneOf,
  CaseType,
  ClaimStatus,
} from "src/constants/api";

import { IDetailState } from "src/reducers/detail";
import FormSelect from "../common/form/controls/select";
import {
  caseTypeData,
  complaintStatusData,
  OnHoldStatusData,
  inCaseOfShipmentData,
} from "../../constants/dropdown";
import {
  actionSaveAttachmentData,
  actionDownloadAttachment,
  actionDeleteAttachment,
} from "src/actions/detail";
import AttachmentContainer from "src/components/common/attachment-container";
import { FORM_TYPE_MAIN, FORM_ERROR_MESSAGE } from "src/constants/data.js";
import FormSelectAutoComplete from "../common/form/controls/select-autocomplete";
import { getStringAfterSubstring, getStringBeforeSubstring } from "../../utils";
import { openToaster, closeToaster } from "src/actions/common";
import PoFormComponent from "./poform";
import AsyncSelect from "react-select/async";
import { apiGetSPUserViaGraph } from "../../effects/api/home";
import { stylesReactSelect } from "../../styles/form";

const CURRENCY_LIST: any = (window as any).currencyList;
const categoryList: any = (window as any).categories;

export interface IMainFormStateProps {
  countries: IDetailState["countries"];
  issueTypes: IDetailState["issueTypes"];
  claimStatus: IDetailState["claimStatus"];
  claimTypes: IDetailState["claimTypes"];
  routeParams: any;
  saveAttachmentData: typeof actionSaveAttachmentData;
  downloadAttachment: typeof actionDownloadAttachment;
  deleteAttachment: typeof actionDeleteAttachment;
  attachmentData: IDetailState["attachmentData"];
  uniqueId: any;
  mainForm: any;
  caseData: any;
  allowEdit: boolean;
  currentRoleId: number;
  isNewCase: boolean;
  dispatch: any;
  isLockForEdit: any;
  countriesData: any;
  currentUser: any;
  currentUsername: any;
  openToaster: typeof openToaster;
  submitFailed: any;
  invalid: any;
  isToasterVisible: any;
  closeToaster: typeof closeToaster;
}

type MainFormProps = IMainFormStateProps & InjectedFormProps;

class MainFormComponent extends React.Component<MainFormProps, any> {
  constructor(props: MainFormProps) {
    super(props);
    this.state = {
      selectedCurrency: "",
      selectedValue: [],
      isValueSet: false,
      errorMsgCoContacts: "",
      // CURRENCY_LIST[1] ? CURRENCY_LIST[0].value : ''
    };
  }

  // Takes the comma-separated string of country IDs and turn it into
  // a comma-separated string of the countries' unicef regions
  formatRegions = (countryStr?: string) => {
    const { countries } = this.props;
    if (!countryStr || !countries) {
      return undefined;
    }
    const onlyUnique = (value: any, index: any, self: any) => {
      return self.indexOf(value) === index;
    };
    const cs = countryStr
      .split(",")
      .map(Number)
      .map((id) => countries.get(id.toString()))
      .filter((val) => val !== undefined)
      .map((c) => c!.unicefregion)
      .filter(onlyUnique);
    return cs.join(", ");
  };

  currencyCheck = (evt: any) => {
    // @ts-ignore
    const { dispatch } = this.props;
    this.setState({ selectedCurrency: evt[0] });
    if (!evt[0]) {
      dispatch(change("mainForm", "expectedLossValue", ""));
    }
    // this.props.setExpectedLossCurrency(evt[0]);
  };

  public componentDidMount() {
    // const { reset } = this.props;
    // reset();
  }

  public UNSAFE_componentWillReceiveProps(nextProps: any) {
    const { values } = nextProps.mainForm.mainForm;
    if (values && values.expectedLossCurrency) {
      this.setState({ selectedCurrency: values.expectedLossCurrency });
    } else {
      this.setState({ selectedCurrency: "" });
    }
  }

  public componentDidUpdate(prevProps: any) {
    const { dispatch } = this.props;
    const { mainForm } = this.props.mainForm;

    if (
      (mainForm &&
        mainForm.values &&
        prevProps.mainForm.mainForm &&
        JSON.stringify(prevProps.mainForm.mainForm.values) !==
        JSON.stringify(this.props.mainForm.mainForm.values)) ||
      this.state.selectedValue.length === 0
    ) {
      let values = mainForm.values;
      if (
        values &&
        !(
          values.submittingTeam === null || values.submittingTeam === undefined
        ) &&
        !this.state.isValueSet
      ) {
        let subTeam: any = [];
        values.submittingTeam.split(",").map((w: any) => {
          var array = w.split("~");
          subTeam.push({ displayName: array[0], mail: array[1] });
        });
        this.setState({
          selectedValue: subTeam,
          isValueSet: true,
          errorMsgCoContacts: "",
        });
      }
    }
  }

  public componentWillUnmount() {
    const { closeToaster, reset } = this.props;
    // reset();
    closeToaster();
  }

  // handle input change event
  private handleInputChange = (value: any) => {
    this.setState({
      inputValue: value,
    });
  };

  // handle selection
  private handleChange = (value: any) => {
    const { dispatch } = this.props;

    if (value && value.length) {
      this.setState({
        selectedValue: value,
        errorMsgCoContacts: "",
      });

      let subteam: any = [];
      value.map((a: any) => {
        subteam.push(`${a.displayName}~${a.mail}`);
      });
      subteam = subteam.join(",");
      dispatch(change("mainForm", "submittingTeam", subteam));
    } else {
      this.setState({
        selectedValue: [],
        errorMsgCoContacts: "",
      });
      dispatch(change("mainForm", "submittingTeam", null));
    }
  };

  private getLabelValue: any = (data: any) => {
    const username = (
      <div style={{ display: "inline-block", marginLeft: "5px" }}>
        <div>
          {data.displayName} ({data.mail})
        </div>
        <div></div>
      </div>
    );
    return username;
  };

  // load options using API call
  private loadOptions = async (inputValue: any, callback: any) => {
    if (inputValue && inputValue.length > 2) {
      let response: any = await apiGetSPUserViaGraph(inputValue);
      callback(response.data);
    } else {
      callback([]);
    }
  };

  public render() {
    const {
      handleSubmit,
      //  countries,
      claimStatus,
      claimTypes,
      saveAttachmentData,
      deleteAttachment,
      downloadAttachment,
      attachmentData,
      uniqueId,
      isNewCase,
      mainForm,
      countriesData,
      submitFailed,
      invalid,
      openToaster,
      isToasterVisible,
      closeToaster,
      dispatch,
    } = this.props;
    const issueTypes = Array.from(this.props.issueTypes?.values() ?? []).filter(issueType => issueType.caseFormType === null);
    // const disableForm = !allowEdit || (caseData && caseData.complaintStatus === false) ? true : false;
    const disableForm = this.disableForm();
    // @ts-ignore
    const formValues = mainForm.mainForm ? mainForm.mainForm.values : null;

    if (submitFailed && invalid) {
      openToaster(FORM_ERROR_MESSAGE, false);
    } else if (!invalid && isToasterVisible) {
      closeToaster();
    }

    // The FieldsArray component gives access to the `fields` object,
    // which lets us update the field array as if it's a normal array
    return (
      <form onSubmit={handleSubmit}>
        <Grid style={{ paddingTop: "25px" }} container={true} spacing={2}>
          <FlexGridItem xs={6}>
            <FlexTextField disabled={true} name="createdBy" label="Submitter" />
          </FlexGridItem>
          <FlexGridItem xs={6}>
            <DateField
              name="created"
              label="Case created"
              format={timestampToDate}
              normalize={dateToTimestamp}
              disabled={true}
            />
          </FlexGridItem>
          <FlexGridItem xs={12}>
            <label
              style={{
                fontSize: "12px",
                fontWeight: "inherit",
                lineHeight: 2,
                position: "absolute",
                marginTop: "-15px",
                paddingLeft: "4px",
                color: "#000000",
                opacity: "0.6",
              }}
              id="aria-label"
              htmlFor="submittingTeam"
            >
              Submitting Team
            </label>
            <AsyncSelect
              cacheOptions
              defaultOptions
              aria-labelledby="aria-label"
              name="submittingTeam"
              placeholder="Start typing to find a user"
              value={this.state.selectedValue}
              getOptionLabel={(e) => this.getLabelValue(e)}
              getOptionValue={(e) => e.mail || e.id}
              loadOptions={this.loadOptions}
              onInputChange={this.handleInputChange}
              onChange={this.handleChange}
              isClearable
              styles={stylesReactSelect}
              isMulti={true}
              isDisabled={disableForm}
            />
          </FlexGridItem>
          <FlexGridItem xs={6}>
            <FlexTextField
              name="submittingOnBehalfOf"
              label="Submitting on behalf of"
              disabled={disableForm}
              validate={[maxLength50]}
            />
          </FlexGridItem>
          <FlexGridItem xs={6}>
            <FlexTextField disabled={true} name="caseNo" label="Case No" />
          </FlexGridItem>
          <FlexGridItem xs={6}>
            <HideForRoles
              roles={[
                UserRoles.Admin,
                UserRoles.INS,
                UserRoles.FMC,
                UserRoles.UNICEF,
                UserRoles.Partner,
                UserRoles.Solution_Owner,
                UserRoles.Solution_Team,
              ]}
            >
              <FlexTextField
                name="complainant"
                label="Complainant"
                validate={[maxLength50]}
                disabled={disableForm}
              />
            </HideForRoles>
          </FlexGridItem>
          <FlexGridItem xs={6}></FlexGridItem>
          <FlexGridItem xs={6}>
            <FlexTextField
              name="contactPerson"
              label="Contact Person"
              required={true}
              disabled={disableForm}
              validate={[required, maxLength50]}
            />
          </FlexGridItem>
          <FlexGridItem xs={6}>
            <HideForRoles roles={[UserRoles.Partner, UserRoles.FMC]}>
              <DisableForRoles
                roles={[
                  UserRoles.UNICEF,
                  UserRoles.Solution_Owner,
                  UserRoles.Solution_Team,
                ]}
                disableField={disableForm}
              >
                <FormSelect
                  label="Case Type"
                  name="caseType"
                  data={caseTypeData}
                  onChange={this.handleChangeCaseType}
                />
              </DisableForRoles>
            </HideForRoles>
          </FlexGridItem>
          <FlexGridItem xs={6}>
            <FlexTextField
              name="phone"
              label="Phone"
              required={true}
              validate={[required, validPhoneNo, maxLength50]}
              disabled={disableForm}
            />
          </FlexGridItem>
          <FlexGridItem xs={6}>
            <HideForRoles roles={[UserRoles.Partner, UserRoles.FMC]}>
              <DisableForRoles
                roles={[
                  UserRoles.UNICEF,
                  UserRoles.INS,
                  UserRoles.Solution_Owner,
                  UserRoles.Solution_Team,
                ]}
                isnewcase={isNewCase}
                disableField={disableForm}
              >
                <ConditionalField
                  formName="mainForm"
                  field="caseType"
                  condition={isComplaint}
                >
                  <FormSelect
                    name="complaintStatus"
                    label="Complaint status"
                    data={complaintStatusData}
                  />
                </ConditionalField>
              </DisableForRoles>
            </HideForRoles>
          </FlexGridItem>
          <ConditionalField
            formName="mainForm"
            field="complaintStatus"
            condition={(val: any) => val === false}
          >
            <FlexGridItem xs={12}>
              <HideForRoles roles={[UserRoles.Partner, UserRoles.FMC]}>
                <DisableForRoles
                  roles={[
                    UserRoles.UNICEF,
                    UserRoles.INS,
                    UserRoles.Solution_Owner,
                    UserRoles.Solution_Team,
                  ]}
                  isnewcase={isNewCase}
                  disableField={disableForm}
                >
                  <ConditionalField
                    formName="mainForm"
                    field="caseType"
                    condition={isComplaint}
                  >
                    <>
                      <FlexGridItem xs={6} />
                      <DateField
                        name="complaintClosureDate"
                        label="Complaint Closure Date"
                        format={timestampToDate}
                        normalize={dateToTimestamp}
                        required={true}
                        validate={[required, validDate]}
                        disabled={disableForm}
                      />
                    </>
                  </ConditionalField>
                </DisableForRoles>
              </HideForRoles>
            </FlexGridItem>
          </ConditionalField>
          <FlexGridItem xs={6}>
            <FlexTextField
              name="email"
              label="Email"
              required={true}
              validate={[required, validEmail, maxLength50]}
              disabled={disableForm}
            />
          </FlexGridItem>
          <FlexGridItem xs={6}>
            <HideForRoles roles={[UserRoles.Partner, UserRoles.FMC]}>
              <DisableForRoles
                roles={[
                  UserRoles.UNICEF,
                  UserRoles.INS,
                  UserRoles.Solution_Owner,
                  UserRoles.Solution_Team,
                ]}
                isnewcase={isNewCase}
                disableField={disableForm}
              >
                <ConditionalField
                  formName="mainForm"
                  field="caseType"
                  condition={isComplaint}
                >
                  <FormSelect
                    name="onHold"
                    label="On Hold"
                    data={OnHoldStatusData}
                  />
                </ConditionalField>
              </DisableForRoles>
            </HideForRoles>
          </FlexGridItem>
          <FlexGridItem xs={6}>
            <FormSelectAutoComplete
              name="countriesAffected"
              label="Select Countries affected"
              data={countriesData}
              isMulti={true}
              disabled={disableForm}
              required={true}
              validate={required}
              onChange={this.changeCountriesAffected}
            />
          </FlexGridItem>
          <FlexGridItem xs={6}>
            <HideForRoles roles={[UserRoles.Partner, UserRoles.FMC]}>
              <DisableForRoles
                roles={[
                  UserRoles.UNICEF,
                  UserRoles.QMU,
                  UserRoles.Solution_Owner,
                  UserRoles.Solution_Team,
                ]}
                isnewcase={isNewCase}
                disableField={disableForm}
              >
                <ConditionalField
                  field="caseType"
                  formName="mainForm"
                  condition={isClaim}
                >
                  <FormSelect
                    name="claimStatus"
                    label="Claim Status"
                    data={claimStatus}
                  />
                </ConditionalField>
              </DisableForRoles>
            </HideForRoles>
          </FlexGridItem>
          <ConditionalField
            formName="mainForm"
            field="claimStatus"
            condition={(val: any) => val === ClaimStatus.Closed}
          >
            <FlexGridItem xs={12}>
              <HideForRoles roles={[UserRoles.Partner, UserRoles.FMC]}>
                <DisableForRoles
                  roles={[
                    UserRoles.UNICEF,
                    UserRoles.QMU,
                    UserRoles.Solution_Owner,
                    UserRoles.Solution_Team,
                  ]}
                  isnewcase={isNewCase}
                  disableField={disableForm}
                >
                  <ConditionalField
                    field="caseType"
                    formName="mainForm"
                    condition={(val: any) => val === CaseType.ComplaintClaim}
                  >
                    <>
                      <FlexGridItem xs={6} />
                      <DateField
                        name="shipments.0.claimClosed"
                        label="Claim Closure Date"
                        format={timestampToDate}
                        normalize={dateToTimestamp}
                        disabled
                      />
                    </>
                  </ConditionalField>
                </DisableForRoles>
              </HideForRoles>
            </FlexGridItem>
          </ConditionalField>
          {/* <FlexGridItem xs={6}>
            <MultiSelect<ICountry>
              getOptionLabel={(c) => c.countryName}
              getOptionValue={(c) => c.id.toString()}
              options={
                countries &&
                Array.from(countries.values()).sort((a, b) =>
                  a.countryName.localeCompare(b.countryName)
                )
              }
              label="Select Countries affected"
              isMulti={true}
              closeMenuOnSelect={false}
              hideSelectedOptions={true}
              normalize={countriesToCountryIdString}
              format={countryIdStringToCountries(countries)}
              name="countriesAffected"
              isDisabled={disableForm}
              required={true}
              validate={[required]}
            />
          </FlexGridItem> */}
          <FlexGridItem xs={6}>
            <FlexTextField name="regions" label="Region(s)" disabled={true} />
          </FlexGridItem>
          <FlexGridItem xs={6}>
            <HideForRoles roles={[UserRoles.Partner, UserRoles.FMC]}>
              <DisableForRoles
                roles={[
                  UserRoles.UNICEF,
                  UserRoles.QMU,
                  UserRoles.Solution_Owner,
                  UserRoles.Solution_Team,
                ]}
                isnewcase={isNewCase}
                disableField={disableForm}
              >
                <ConditionalField
                  field="caseType"
                  formName="mainForm"
                  condition={isClaim}
                >
                  <FormSelect
                    name="claimType"
                    label="Claim Type"
                    data={claimTypes}
                  />
                </ConditionalField>
              </DisableForRoles>
            </HideForRoles>
          </FlexGridItem>

          {/* <FlexGridItem xs={6}>
            <ControlledTextField
              name="countriesAffected"
              label="Region(s)"
              format={this.formatRegions}
              hideadornment={true}
            />
            <FlexTextField
              name="submittingOnBehalfOf"
              label="Submitting on behalf of"
              format={this.formatRegions}
            />
          </FlexGridItem> */}
          <FlexGridItem xs={6}>
            {/*<ConditionalField field="caseType" formName="mainForm" condition={isClaim}>
              <DateField name="insurancePolicyYear" label="Insurance policy year" format={timestampToDate} normalize={dateToTimestamp} />
            </ConditionalField>*/}
            <ConditionalField
              field="caseType"
              formName="mainForm"
              condition={isClaim}
            >
              <EnableForRoles roles={[UserRoles.INS]}>
                <FlexTextFieldNumber
                  name="insurancePolicyYear"
                  label="Insurance policy year (YYYY)"
                  validate={validYear}
                  disabled={disableForm}
                />
              </EnableForRoles>
            </ConditionalField>
          </FlexGridItem>
          <FlexGridItem xs={6}>
            <HideForRoles
              roles={[
                UserRoles.Partner,
                UserRoles.UNICEF,
                UserRoles.QMU,
                UserRoles.FMC,
                UserRoles.Solution_Owner,
                UserRoles.Solution_Team,
              ]}
            >
              <ConditionalField
                field="caseType"
                formName="mainForm"
                condition={isClaim}
              >
                <div className="cb-form-container">
                  <CheckBoxField
                    label="Legal"
                    name="legal"
                    disabled={disableForm}
                  />
                  <span style={{ marginLeft: "-12px" }}>Legal</span>
                </div>
              </ConditionalField>
            </HideForRoles>
          </FlexGridItem>
          <FlexGridItem xs={6}>
            <HideForRoles
              roles={[
                UserRoles.Partner,
                UserRoles.UNICEF,
                UserRoles.QMU,
                UserRoles.FMC,
                UserRoles.Solution_Owner,
                UserRoles.Solution_Team,
              ]}
            >
              <ConditionalField
                field="legal"
                formName="mainForm"
                condition={Boolean}
              >
                <TextArea
                  name="legalComments"
                  label="Legal comments"
                  disabled={disableForm}
                />
              </ConditionalField>
            </HideForRoles>
          </FlexGridItem>
          <HideForRoles
            roles={[
              UserRoles.Partner,
              UserRoles.UNICEF,
              UserRoles.FMC,
              UserRoles.Solution_Owner,
              UserRoles.Solution_Team,
            ]}
          >
            <ConditionalField
              field="caseType"
              formName="mainForm"
              condition={(caseType: CaseType) => isClaim(caseType) && isComplaint(caseType)}
            >
              <React.Fragment>
                <FlexGridItem xs={12}>
                  <FlexTextField
                    name="internalComments"
                    label="Internal Comments"
                    disabled={disableForm}
                  />
                </FlexGridItem>
              </React.Fragment>
            </ConditionalField>
          </HideForRoles>
          <FlexGridItem xs={12}>
            <TextArea
              name="descriptionOfTheIssue"
              label="Description of the issue"
              validate={required}
              required={true}
              disabled={disableForm}
            />
          </FlexGridItem>
          <FlexGridItem xs={6}>
            <DateField
              name="dateIssueNoticed"
              label="Date issue noticed"
              format={timestampToDate}
              normalize={dateToTimestamp}
              required={true}
              validate={[required, validDate]}
              disabled={disableForm}
            />
          </FlexGridItem>
          <FlexGridItem xs={6}>
            <SelectField
              name="expectedLossCurrency"
              label="Currency"
              onChange={this.currencyCheck}
              style={{
                width: "100%",
              }}
              disabled={disableForm}
            >
              <option value={undefined} />
              {CURRENCY_LIST.map((item: any) => (
                <option key={item.value} value={item.value}>
                  {item.label}
                </option>
              ))}
            </SelectField>
            <FlexCurrencyInputField
              style={{ width: "80%" }}
              name="expectedLossValue"
              label="Expected loss value"
              validate={[validCurrency, maxLength50]}
              iscurrency={true}
              selected={this.state.selectedCurrency}
              disabled={!this.state.selectedCurrency || disableForm}
            />
          </FlexGridItem>
          <FlexGridItem xs={6}>
            <div style={{ width: "100%" }}>
              <FormSelect
                name="issueType"
                label="Issue Type"
                data={issueTypes}
                validate={required}
                required={true}
                disabled={disableForm}
              />
              <p style={{ color: "red" }}>
                Please attach any relevant documents as evidence of the
                case/loss/damage, for instance: Pictures, Invoices/Certificates,
                Goods receipts and Others
              </p>
            </div>
          </FlexGridItem>
          <FlexGridItem xs={6}>
            <div style={{ width: "100%" }}>
              <FormSelect
                name="category"
                label="Category"
                data={categoryList}
                validate={required}
                required={true}
                disabled={disableForm}
              />
            </div>
          </FlexGridItem>
          <AttachmentContainer
            label="Attachments"
            //uniqueId={uniqueId}
            onSave={saveAttachmentData}
            attachment={attachmentData}
            download={downloadAttachment}
            remove={deleteAttachment}
            type={FORM_TYPE_MAIN}
            disabled={disableForm}
            {...this.props}
          />
          <FlexGridItem xs={6}>
            <ConditionalField
              field="issueType"
              formName="mainForm"
              condition={isOneOf(IssueType.Shipment)}
            >
              <FormSelect
                name="inCaseOfShipment"
                label="In case of shipment"
                data={inCaseOfShipmentData}
                validate={required}
                required={true}
                disabled={disableForm}
              />
            </ConditionalField>
          </FlexGridItem>
          <FlexGridItem xs={12}>
            {/*<FlexTextField name="comments" label="Comments" />*/}
            <TextArea name="comments" label="Comments" disabled={disableForm} />
          </FlexGridItem>
          {/* <FlexGridItem xs={6}>
            <FlexTextField name="poNo" label="PO No" />
          </FlexGridItem>
          <FlexGridItem xs={6}>
            <FlexTextField name="deliveryNo" label="Delivery No" />
          </FlexGridItem>
          <FlexGridItem xs={6}>
            <FlexTextField name="shipmentNo" label="Shipment No" />
          </FlexGridItem> */}

          <FlexGridItem xs={12} />

          <FieldArray
            name="pos"
            component={PoFormComponent as any}
            // @ts-ignore
            props={{
              dispatch,
              disableForm,
              mainForm,
              isToasterVisible,
              openToaster,
            }}
          />
        </Grid>
      </form>
    );
  }

  private changeCountriesAffected = (event: any, values: any) => {
    const { dispatch } = this.props;
    if (values && values.length) {
      const unique = values
        .map((item: any) => item.unicefregion)
        .filter(
          (value: any, index: any, self: any) => self.indexOf(value) === index
        )
        .toString();
      if (unique) {
        dispatch(change("mainForm", "regions", unique));
      } else {
        dispatch(change("mainForm", "regions", "UNKOWN"));
      }
    } else {
      dispatch(change("mainForm", "regions", ""));
    }
  };

  private disableForm = () => {
    const {
      caseData,
      currentRoleId,
      allowEdit,
      isNewCase,
      isLockForEdit,
      mainForm,
      currentUsername,
    } = this.props;
    let disableForm = false;
    if (!allowEdit) {
      disableForm = true;
    } else if (!isNewCase && caseData) {
      if (currentRoleId === UserRoles.UNICEF && isLockForEdit) {
        disableForm = true;
      } else if (
        currentRoleId === UserRoles.Solution_Owner ||
        currentRoleId === UserRoles.Solution_Team
      ) {
        // Get username who created the case
        let createdBy = mainForm.mainForm.values.createdBy;
        createdBy = getStringAfterSubstring(createdBy, "(");
        createdBy = getStringBeforeSubstring(createdBy, ")").trim();

        if (currentUsername !== createdBy || isLockForEdit) {
          disableForm = true;
        }
      }
    }
    return disableForm;
  };

  private handleChangeCaseType = (event: any) => {
    const caseTypeValue = event.target.value;
    const { dispatch } = this.props;
    if (caseTypeValue === CaseType.Claim) {
      // Reset Complaint Status field
      dispatch(change("mainForm", "complaintStatus", null));
      dispatch(change("mainForm", "onHold", null));
    } else if (caseTypeValue === CaseType.Complaint) {
      // Reset Claim Status, Claim Type and Insurance policy year field
      dispatch(change("mainForm", "claimStatus", null));
      dispatch(change("mainForm", "claimType", null));
      dispatch(change("mainForm", "insurancePolicyYear", null));
      dispatch(change("mainForm", "complaintStatus", true));
      dispatch(change("mainForm", "onHold", false));
    }
  };
}

function mapStateToProps(state: any) {
  setTimeout(() => { }, 100);
  return {
    countries: state.detail.countries,
    issueTypes: state.detail.issueTypes,
    claimStatus: state.detail.claimStatus,
    claimTypes: state.detail.claimTypes,
    mainForm: state.form,
    route: state.routing,
    attachmentData: state.detail.attachmentData,
    caseData: state.detail.caseData,
    allowEdit: state.detail.allowEdit,
    isLockForEdit: state.detail.isLockForEdit,
    countriesData: state.detail.countriesData,
    currentUser: state.home.currentUser,
    currentUsername: state.detail.currentUsername,
    isToasterVisible: state.common.isToasterVisible,
  };
}

const mapDispatchToProps = (dispatch: any) => {
  return {
    saveAttachmentData: (
      file: any,
      uploadedBy: any,
      uniqueId: any,
      prevAttachmentData: any,
      type: string
    ) =>
      dispatch(
        actionSaveAttachmentData(
          file,
          uploadedBy,
          uniqueId,
          prevAttachmentData,
          type
        )
      ),
    downloadAttachment: (fileId: any) =>
      dispatch(actionDownloadAttachment(fileId)),
    deleteAttachment: (fileId: any, attachmentData: any, type: string) =>
      dispatch(actionDeleteAttachment(fileId, attachmentData, type)),
    openToaster: (message: string, success: boolean) =>
      dispatch(openToaster(message, success)),
    closeToaster: () => dispatch(closeToaster()),
  };
};

// mainForm is the name of the form object for the Redux form state store.
// enableReinitialize enables changes to initial data to render.
// keepDirtyOnReinitialize enables to keep edited data on reinitialize.
// destroyOnUnmount enables that data is kept when changing tabs.

export default reduxForm({
  enableReinitialize: true,
  form: "mainForm",
  destroyOnUnmount: false,
  keepDirtyOnReinitialize: true,
  updateUnregisteredFields: true,
})(connect(mapStateToProps, mapDispatchToProps)(MainFormComponent));
